<template>
  <fieldset class="card" v-if="user">
    <the-overlay :active="state === 'INI'">

      <data-table
        table-id="user-table"
        class="table table-borderless no-margin"
        :columns="userColumns"
        :items="[user]" />

    </the-overlay>
  </fieldset>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { mapActions } from 'pinia';
import DataTable, { TableColumns } from '@/components/ui/DataTable.vue';
import Backend, { OrganizationDetails, UserData } from '@/components/backend';
import useUserStore from '@/components/store/users.store';
import TheOverlay from '@/components/ui/TheOverlay.vue';

export default defineComponent({
  name: 'UserTable',
  components: { TheOverlay, DataTable },
  props: {
    user: { type: Object as PropType<UserData>, required: true },
  },
  data: () => ({
    organization: undefined as OrganizationDetails | undefined,
    state: 'INI' as 'INI' | 'RDY' | 'ERR',
  }),
  computed: {
    userColumns(): TableColumns {
      return {
        email: { label: this.$t('adm.label.email') },
        firstname: { label: this.$t('adm.label.firstname') },
        lastname: { label: this.$t('adm.label.lastname') },
        organization: {
          label: this.$t('adm.label.organization'),
          decorator: () => (
            this.organization?.name ?? `<span class="text-danger">${this.$t('adm.error.ORGANIZATION_NOT_FOUND')}</span>`
          ),
        },
        crmNo: { label: this.$t('adm.label.crmNo'), decorator: () => (this.organization?.crmNo ?? '-') },
        crmId: { label: this.$t('adm.label.crmId'), itemClass: 'fs-6' },
      };
    },
  },
  methods: {
    ...mapActions(useUserStore, {
      getOrganization: 'getOrganization',
    }),
  },
  mounted() {
    // if organization is already loaded -> skip
    this.organization = this.getOrganization(this.user.organization);
    if (this.organization) {
      this.state = 'RDY';
      return;
    }

    // if not -> load
    Backend.validateToken().then((api) => api
      .loadOrganization(this.user.organization, { $select: 'id,name,crmNo' })
      .then((r) => {
        this.organization = r.data;
        this.state = 'RDY';
      })
      .catch(() => {
        this.state = 'ERR';
      }));
  },
});
</script>

<style>
#user-table {
  --bs-table-bg: var(--grey-light);
  --stihl-table-filter: none;
}

</style>
